/**
 * Scroll position calculation utilities for SchedulingDayBox
 */

/**
 * 타임라인 슬롯 높이 (픽셀)
 */
export const SLOT_HEIGHT = 34

/**
 * 슬롯당 분 수
 */
export const MINUTES_PER_SLOT = 30

/**
 * Calculate scroll position to center a specific time in the viewport
 *
 * @param targetTime - The time to scroll to
 * @param containerHeight - Height of the scroll container
 * @returns Scroll position in pixels
 */
export const calculateScrollPosition = (targetTime: Date, containerHeight: number): number => {
  const hours = targetTime.getHours()
  const minutes = targetTime.getMinutes()
  const totalMinutes = hours * 60 + minutes
  const position = (totalMinutes / MINUTES_PER_SLOT) * SLOT_HEIGHT

  // Center the target time in the viewport
  const centerPosition = position - containerHeight / 2 + SLOT_HEIGHT / 2

  // Ensure non-negative scroll position
  return Math.max(centerPosition, 0)
}
